import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Clip, LinkedGroup } from 'components/app/editor/_mediator/editor.slice';
import { LinkedIndex } from 'components/app/storyboard/_mediator/sb.slice';

export type TimestampRange = {
  minTime: EditorTime;
  maxTime: EditorTime;
};
export type ClipNeighbors = {
  leftNeighbor: Clip | null;
  rightNeighbor: Clip | null;
};
export type Boundaries = {
  boundaryLeft: CellClip;
  boundaryRight: CellClip;
};
export type TsPayload = LinkedIndex & TimestampRange & ClipNeighbors & Boundaries & { group: LinkedGroup };

interface State {
  tsLinkedPayload: TsPayload | null;
  tsLinkedListener: object;
  hotkeyPlayerTimeListener: EditorTime | null;
  timeBoundaryClip: CellClip | null;
  currentPlayerDuration: EditorTime;
}

const initialState: State = {
  tsLinkedPayload: null,
  tsLinkedListener: {},
  hotkeyPlayerTimeListener: null,
  timeBoundaryClip: null,
  currentPlayerDuration: 0,
};

// T H U N K S

// S L I C E

export const timestamp = createSlice({
  name: 'timestamp',
  initialState,
  reducers: {
    setTsLinkedPayload: (state, action: PayloadAction<TsPayload | null>) => {
      state.tsLinkedPayload = action.payload;
      state.tsLinkedListener = {};
    },
    setHotkeyPLayerTimeListener: (state, action: PayloadAction<State['hotkeyPlayerTimeListener']>) => {
      state.hotkeyPlayerTimeListener = action.payload;
    },
    setTimeBoundaryClip: (state, action: PayloadAction<State['timeBoundaryClip']>) => {
      state.timeBoundaryClip = action.payload;
    },
    setCurrentPlayerDuration: (state, action: PayloadAction<EditorTime>) => {
      state.currentPlayerDuration = action.payload;
    },
  },
});

export const { setTsLinkedPayload, setTimeBoundaryClip, setHotkeyPLayerTimeListener, setCurrentPlayerDuration } =
  timestamp.actions;
export default timestamp.reducer;
